"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalBigCategorynews(t0) {
  const $ = _c(64);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    priority: t6,
    imageMetadata
  } = t0;
  let t7;
  if ($[0] !== t1) {
    t7 = t1 === undefined ? {
      hidden: false,
      value: "lifestyle",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const category = t7;
  let t8;
  if ($[2] !== t2) {
    t8 = t2 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const title = t8;
  let t9;
  if ($[4] !== t3) {
    t9 = t3 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const excerpt = t9;
  let t10;
  if ($[6] !== t4) {
    t10 = t4 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const timeAgo = t10;
  let t11;
  if ($[8] !== t5) {
    t11 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[8] = t5;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const imageSrc = t11;
  const priority = t6 === undefined ? false : t6;
  const router = useRouter();
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  let t12;
  if ($[10] !== imageSrc?.value) {
    t12 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const imageSrcValue = t12;
  const categoryValue = category?.value || "";
  const t13 = timeAgo?.value;
  let t14;
  if ($[12] !== t13) {
    t14 = getTimeAgo(t13);
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  const timeAgoValue = t14;
  let t15;
  if ($[14] !== router || $[15] !== sectionUrl) {
    t15 = e => {
      if (sectionUrl) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrl);
      }
    };
    $[14] = router;
    $[15] = sectionUrl;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const handleCategoryClick = t15;
  const t16 = `/${slug}`;
  let t17;
  if ($[17] !== imageMetadata || $[18] !== imageSrc?.customClass || $[19] !== imageSrc?.hidden || $[20] !== imageSrcValue || $[21] !== priority || $[22] !== titleValue) {
    t17 = !imageSrc?.hidden && <div className={`flex-shrink-0 ${imageSrc?.customClass || ""}`}><div className="relative w-[106px] h-[76px] md:w-[150px] md:h-[110px] lg:w-[180px] lg:h-[130px] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} sizes="(max-width: 768px) 100px, 300px" className="object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[17] = imageMetadata;
    $[18] = imageSrc?.customClass;
    $[19] = imageSrc?.hidden;
    $[20] = imageSrcValue;
    $[21] = priority;
    $[22] = titleValue;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== category?.customClass || $[25] !== category?.hidden || $[26] !== categoryValue || $[27] !== handleCategoryClick || $[28] !== sectionUrl) {
    t18 = !category?.hidden && <>{sectionUrl ? <span className={`text-11-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <div className={`text-11-tamil-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>}</>;
    $[24] = category?.customClass;
    $[25] = category?.hidden;
    $[26] = categoryValue;
    $[27] = handleCategoryClick;
    $[28] = sectionUrl;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== title?.customClass || $[31] !== title?.hidden || $[32] !== titleValue) {
    t19 = !title?.hidden && <h3 className={`text-14-tamil-700 text-012061 leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[30] = title?.customClass;
    $[31] = title?.hidden;
    $[32] = titleValue;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== excerpt?.customClass || $[35] !== excerpt?.hidden || $[36] !== excerptValue) {
    t20 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-4D4D4D leading-[1.3] line-clamp-2 opacity-70 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[34] = excerpt?.customClass;
    $[35] = excerpt?.hidden;
    $[36] = excerptValue;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t18 || $[39] !== t19 || $[40] !== t20) {
    t21 = <div className="flex flex-col gap-1 md:gap-2">{t18}{t19}{t20}</div>;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== timeAgo?.customClass || $[43] !== timeAgo?.hidden || $[44] !== timeAgoValue) {
    t22 = !timeAgo?.hidden && <p className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</p>;
    $[42] = timeAgo?.customClass;
    $[43] = timeAgo?.hidden;
    $[44] = timeAgoValue;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  const t23 = slug ? `/${slug}` : undefined;
  let t24;
  if ($[46] !== excerptValue || $[47] !== imageSrcValue || $[48] !== slug || $[49] !== t23 || $[50] !== titleValue) {
    t24 = <div className="flex gap-3" onClick={_temp}><MessageIcon id="message-icon-3" variant="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t23} /></div>;
    $[46] = excerptValue;
    $[47] = imageSrcValue;
    $[48] = slug;
    $[49] = t23;
    $[50] = titleValue;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t22 || $[53] !== t24) {
    t25 = <div className="flex justify-between items-center gap-2">{t22}{t24}</div>;
    $[52] = t22;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t21 || $[56] !== t25) {
    t26 = <div className="flex flex-col justify-between gap-2 w-full">{t21}{t25}</div>;
    $[55] = t21;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t17 || $[59] !== t26) {
    t27 = <article className="text-FFFFFF p-4 mb-0 align-center cursor-pointer"><div className="flex gap-4">{t17}{t26}</div></article>;
    $[58] = t17;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t16 || $[62] !== t27) {
    t28 = <Link href={t16} className="block  transition-colors cursor-pointer">{t27}</Link>;
    $[61] = t16;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  return t28;
}
function _temp(e_0) {
  return e_0.stopPropagation();
}